import { AxiosResponse } from 'axios';
import {
  B2C_PAYMENTS_PATH,
  PAYPAL_CANCEL_REDIRECT_PATH,
  B2C_PAYPAL_INIT_PATH,
  PAYPAL_RETURN_PATH,
  B2C_PAYPAL_SAVE_PATH,
} from '../../constants/links';
import {
  IB2CPaymentCardsResponse,
  IB2CPaypalInitResponse,
  IB2CEditPaymentCardResponse,
  IB2CPaymentCard,
} from '../../models/b2c/payments';
import { apiB2C } from '../axios-client';
import { withMemberId } from '../utils';

export const b2cPaymentsApi = {
  getCreditAndPaypalCards: withMemberId(
    (memberId): Promise<AxiosResponse<IB2CPaymentCardsResponse>> =>
      apiB2C.get(B2C_PAYMENTS_PATH(memberId), {
        params: {
          pageSize: 0,
          pageNumber: 0,
        },
      }),
  ),
  paypalInit: withMemberId(
    (memberId): Promise<AxiosResponse<IB2CPaypalInitResponse>> =>
      apiB2C.put(B2C_PAYPAL_INIT_PATH(memberId), {
        paypal: {
          cancelUrl: PAYPAL_CANCEL_REDIRECT_PATH(),
          returnUrl: PAYPAL_RETURN_PATH(),
          requestType: 'InitPaypal',
        },
      }),
  ),
  paypalSave: withMemberId(
    (memberId, tokenId: string, payerId?: string | null): Promise<void> =>
      apiB2C.put(B2C_PAYPAL_SAVE_PATH(memberId), {
        paypal: {
          tokenId,
          payerId,
          requestType: 'VerifyAndSave',
        },
      }),
  ),
  deletePayments: withMemberId((memberId, paymentId: string) =>
    apiB2C.post(`${B2C_PAYMENTS_PATH(memberId)}/delete`, {
      PaymentCardRequest: { paymentId },
    }),
  ),
  updateCreditCard: withMemberId(
    (
      memberId,
      creditCard: IB2CPaymentCard,
    ): Promise<AxiosResponse<IB2CEditPaymentCardResponse>> => {
      const payload = {
        paymentCards: {
          paymentCard: [creditCard],
        },
      };
      return apiB2C.put(B2C_PAYMENTS_PATH(memberId), payload);
    },
  ),
};
